import React from 'react';
import PropTypes from 'prop-types';

// Human-readable label from a contract shape symbol,
// e.g. round_lines_horizontal → "Round lines horizontal".
function humanize(name) {
  return name.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
}

class ShapeSwatchPicker extends React.Component {
  render() {
    const {
      options, swatches, value, onChange,
    } = this.props;
    return (
      <div className="shape-swatch-grid" role="group">
        {options.map((name) => {
          const active = value === name;
          const svg = swatches[name] || '';
          return (
            <button
              key={name}
              type="button"
              className={`shape-swatch-tile${active ? ' is-active' : ''}`}
              aria-pressed={active}
              aria-label={humanize(name)}
              title={humanize(name)}
              onClick={() => onChange(name)}
            >
              {/* Safety note: dangerouslySetInnerHTML is acceptable here because the SVG comes
                  exclusively from our own server-side SwatchRenderer (embedded in the mount
                  props), never from user input. */}
              <span className="shape-swatch-thumb" dangerouslySetInnerHTML={{ __html: svg }} />
            </button>
          );
        })}
      </div>
    );
  }
}

ShapeSwatchPicker.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  swatches: PropTypes.objectOf(PropTypes.string).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ShapeSwatchPicker;
